import { render, staticRenderFns } from "./TherapyManagementBlock.vue?vue&type=template&id=b75df19a&scoped=true"
import script from "./TherapyManagementBlock.vue?vue&type=script&lang=js"
export * from "./TherapyManagementBlock.vue?vue&type=script&lang=js"
import style0 from "./TherapyManagementBlock.vue?vue&type=style&index=0&id=b75df19a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75df19a",
  null
  
)

export default component.exports